import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getCustomers = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/customers';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const customerAPI = {
    getCustomers
}

export default customerAPI
